import { EUserStatus } from './userStatus';
import { EErrorType, IErrorSchema } from '../../repositories/dailyrent/entities/response/ErrorSchema';

export type TGeneralRating = {
  value: number;
};
export type TEcologyRating = {
  value: number;
};
export type TInfrastructureRating = {
  value: number;
};
export type TTransportRating = {
  value: number;
};
export type TPriceAndQualityBalanceRating = {
  value: number;
};
export type TUserStatusRating = {
  value: EUserStatus;
};
export type TProsRating = {
  value: string | null;
};
export type TConsRating = {
  value: string | null;
};
export type TName = {
  value: string | null;
};

export type TIsAnonymous = {
  value: boolean | null;
};

export enum ENewReviewMode {
  Full = 'full',
  SkipFlow = 'skipFlow',
}

export enum ENewReviewStep {
  FlowSelection = 'FlowSelection',
  Rating = 'rating',
  Review = 'review',
  Success = 'success',
  Error = 'error',
}

export interface INewReview {
  meta: {
    open: boolean;
    step: ENewReviewStep;
    reviewAllowed: boolean;
  };
  data: {
    generalRating: TGeneralRating;
    ecologyRating: TEcologyRating;
    infrastructureRating: TInfrastructureRating;
    priceAndQualityBalanceRating: TPriceAndQualityBalanceRating;
    transportRating: TTransportRating;
    name: TName;
    userStatus: TUserStatusRating;
    pros: TProsRating;
    cons: TConsRating;
    isAnonymous: TIsAnonymous;
  };
}

export enum ENewReviewFlow {
  Success = 'successful',
  Fail = 'canceled',
  FailedToAgree = 'communication',
}

export type TNewReviewRejectAccessType = EErrorType | 'unknown';

export interface INewReviewRejectAccessError extends Omit<IErrorSchema, 'errorType'> {
  errorType: TNewReviewRejectAccessType;
}
